// Aufgabe laden (02.11.2026): "nicht gefunden" nur bei HTTP 404; 5xx/Netzwerk = Ladefehler mit kurzer Wiederholung.

/** Nur HTTP 404 bedeutet "nicht gefunden"; alles andere (5xx, Netzwerk, Abbruch) ist ein Ladefehler (02.11.2026). */
export function aufgabeLadefehlerArt(e) {
  return e?.status === 404 ? 'nicht_gefunden' : 'nicht_erreichbar';
}

/** Kurze Wiederholung bei 5xx/Netzwerkfehler, z. B. waehrend eines Backend-Neustarts (Praxisfall 02.11.2026: 502 -> "nicht gefunden"). */
export async function ladeAufgabeMitWiederholung(id, laden, pausen = [1500, 3000, 5000]) {
  for (let versuch = 0; ; versuch++) {
    try {
      return await laden(id);
    } catch (e) {
      if (aufgabeLadefehlerArt(e) === 'nicht_gefunden' || (e?.status && e.status < 500) || versuch >= pausen.length) throw e;
      await new Promise((r) => setTimeout(r, pausen[versuch]));
    }
  }
}
